const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/catalog/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { isCatalogTab } from "@/components/admin/catalog/catalog-tabs";
export const Route = createFileRoute("/dashboard/admin/catalog/")({
  validateSearch: (search: Record<string, unknown>): {
    tab?: CatalogTab;
  } => isCatalogTab(search.tab) ? {
    tab: search.tab
  } : {},
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});